import Name from './Name';
import StudentNo from './StudentNo';
import SearchInput from './SearchInput';
import BatchNo from './BatchNo';
import DatePickers from './DatePickers';

export default {
    Name,
    StudentNo,
    BatchNo,
    SearchInput,
    DatePickers
}